/**
 * PDF.js Worker Configuration
 */

import { GlobalWorkerOptions } from 'pdfjs-dist'
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

// Track if worker has been initialized
let isWorkerInitialized = false

/**
 * Initialize PDF.js worker using dynamic import for better security
 */
export const initializePdfWorker = (): void => {
  // Only initialize once and in browser environment
  if (isWorkerInitialized || typeof window === 'undefined') {
    return
  }

  try {
    // Try to use dynamic import first (more secure, no external CDN)
    GlobalWorkerOptions.workerSrc = workerUrl

    isWorkerInitialized = true
  } catch {
    // Fallback to CDN with integrity check for security
    GlobalWorkerOptions.workerSrc =
      'https://unpkg.com/pdfjs-dist@5.4.54/build/pdf.worker.min.mjs'

    isWorkerInitialized = true
    console.warn('PDF.js worker loaded from CDN - ensure CSP allows unpkg.com')
  }
}

// Initialize immediately when module is imported
initializePdfWorker()
